const carouselItems = [
  {
    id: 1,
    title: '暑期档热门电影大盘点',
    desc: '精选今夏最受瞩目的院线大片和网络热映影片，涵盖动作、喜剧、悬疑等多种类型',
    tag: '专题推荐',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summer%20cinema%20vibe%20with%20abstract%20film%20projector%20casting%20golden%20light%20beams%2C%20floating%20movie%20tickets%20and%20popcorn%2C%20cinematic%20atmosphere%20with%20soft%20warm%20tones%2C%20nostalgic%20theater%20aesthetic%2C%20elegant%20composition%20with%20rich%20amber%20and%20cream%20colors&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分悬疑剧追剧指南',
    desc: '烧脑剧情层层反转，带你体验智力与心理的双重震撼',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20detective%20atmosphere%20with%20dramatic%20shadow%20play%2C%20magnifying%20glass%20on%20dark%20wooden%20desk%2C%20soft%20foggy%20lighting%2C%20suspenseful%20cinematic%20aesthetic%2C%20warm%20dark%20tones%20with%20amber%20accents%2C%20film%20noir%20composition&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '经典港片修复版重温',
    desc: '那些年的经典镜头，高清修复画质带你重回港片黄金时代',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cinema%20aesthetic%20with%20neon%20signs%20and%20old%20film%20posters%20on%20brick%20wall%2C%20warm%20vintage%20lighting%2C%20nostalgic%20movie%20theater%20atmosphere%2C%20rich%20warm%20golden%20and%20red%20tones%2C%20classic%20film%20era%20composition&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '热门综艺精彩片段合集',
    desc: '爆笑名场面、感人瞬间，全网热门综艺精华一站收录',
    tag: '综艺精选',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20television%20studio%20with%20dynamic%20stage%20lighting%20and%20audience%20silhouettes%2C%20vibrant%20entertainment%20show%20atmosphere%2C%20professional%20broadcast%20production%20scene%2C%20energetic%20warm%20lighting%20design%2C%20modern%20variety%20show%20aesthetic&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '国产科幻片崛起之路',
    desc: '从特效突破到叙事升级，国产科幻影视作品的最新探索与成就',
    tag: '深度策划',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20scifi%20cinematic%20scene%20with%20abstract%20digital%20particles%20and%20warm%20golden%20light%20beams%2C%20space%20nebula%20texture%20in%20background%2C%20elegant%20technology%20aesthetic%2C%20professional%20film%20visual%20effects%20style%2C%20rich%20deep%20blue%20and%20amber%20contrast&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              深度策划的影视专题内容，发现更多精彩
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.slice(0, 3).map((item) => (
              <article key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <span className="absolute top-3 left-3 px-2 py-1 text-xs font-medium text-background-50 bg-primary-500/90 rounded-md">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
            {carouselItems.slice(3).map((item) => (
              <article key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer">
                <div className="flex flex-col sm:flex-row">
                  <div className="relative sm:w-2/5 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <span className="absolute top-3 left-3 px-2 py-1 text-xs font-medium text-background-50 bg-accent-500/90 rounded-md">
                      {item.tag}
                    </span>
                  </div>
                  <div className="flex-1 p-5 flex flex-col justify-center">
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}